export default __webpack_public_path__ + "static/sc-local-cad2a46b2f2500c9587035ea1f99b404.webp";